export default __webpack_public_path__ + "static/media/support.a85733cb.svg";